module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABHNCSVQICAgIfAhkiAAAASdJREFUSInFlTtywjAQQJ801hXgGm6oKFJl1CQNt0guAbkEuQUNNB4qCioaXwOuII+dAokRxo7XZpyok2b3PWn1g79qh/12dcw2k2c5x2wzOey3y9BXAQ4sAZLSTed2cRkKL7Q5++7q5fX9S3voOgQV2pyHrKQGJyndN4AGmNvFJSndNJLs+kg8fBfBb1XQYTCSnICZVBLBZ8CpXmIlSHhr2xNJ7INAmiidSKOgC9Bnla2CNhBcD4EE3imoS6qKXF0zUglcJAgSp0ymFKkfypPSWcmF1F0Bt5lEU6kqaZZAEJUoBXJfplR6T34VNGyyNZWz9LiM/3NMR71ooz4VfeDSHFULDO+5CN4iuXuuVQN80K/WxtAAhTafz8Ch8dP6uAsY69Mfvf0Arcw4h+ihrg8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/icon@2x.png
// module id = i8cj
// module chunks = 1